import type { ReactNode } from "react";

import type { SupportedLocale } from "../i18n";
import { AppErrorBoundary } from "./AppErrorBoundary";
import { BootReveal } from "./BootReveal";

/**
 * What main.tsx renders around the app (ADR-WBC1). BootReveal sits OUTSIDE
 * the error boundary: when the app's first render throws (a screen chunk that
 * will not load), the boundary's message commits instead of the app, and the
 * head script's `data-boot-hide` mark must still be removed in that commit,
 * or #root (and the message with it) would stay display: none.
 */
export function BootRoot({ children, locale }: { children: ReactNode; locale: SupportedLocale }) {
  return (
    <BootReveal>
      <AppErrorBoundary locale={locale}>{children}</AppErrorBoundary>
    </BootReveal>
  );
}
